import axios from '@utils/axios';

export async function postGenTalk(params: GenTalkParams): Promise<{
  predict_id: string;
  task_id: string;
  message: string;
  status: number;
}> {
  const result = await axios.post(
    '/api/gen/talk',
    { ...params },
    {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  );

  if (result?.data?.message) {
    result.data.message = result.message;
  }

  result.data.status = result.status;

  return result?.data;
}

export async function postGenCost(params: {
  prompt: string;
  duration?: number;
  transparency?: number;
  hd_type?: number;
}): Promise<{
  cost_credit: number;
  cost_detail: CostDetails;
  duration: number;
}> {
  const result = await axios.post(
    '/api/gen/cost',
    { ...params },
    {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return result?.data;
}
